import { IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { AdOptions, AdSize, AdPosition } from "capacitor-admob";
import { Plugins, Capacitor } from '@capacitor/core';

import './Main.css'; 

const AdTest : React.FC = () => {

    const { AdMob } = Plugins;

    // initialize
    const init = () => {
        // initialize AdMob
        AdMob.initialize("ca-app-pub-7044197709885078~4321489700");
    }

    // banner ad
    const banner = () => {
        let options: AdOptions = {
            adId: "ca-app-pub-7044197709885078/9382244690",
            adSize: AdSize.SMART_BANNER,
            position: AdPosition.BOTTOM_CENTER,
            hasTabBar: true
        };

        AdMob.showBanner(options).then(
            (value : any) => {
                alert("Success-> " + value.toString());     // true
            },
            (error : any) => {
                alert("Error-> " + error.toString());   // show error
            }
        );
    }

    // interstitial ad
    const interstitial = () => {
        let options : AdOptions = {
            adId: "ca-app-pub-7044197709885078/8069163025",
            autoShow: true,
            isTesting: true
        };

        // Prepare interstitial banner
        AdMob.prepareInterstitial(options).then(
            (value : any) => {
                alert("Success-> " + value.toString()); // true
            },
            (error : any) => {
                alert("Error-> " + error.toString()); // show error
            }
        );
 
        // Subscibe Banner Event Listener
        AdMob.addListener("onAdLoaded", (info: boolean) => {
            alert("Interstitial Ad Loaded-> " + info);
            // show the interstitial
            AdMob.showInterstitial();
        });
    }

    // reward ad
    const reward = () => {
        let options: AdOptions = {
            adId: "ca-app-pub-7044197709885078/1503754677",
            autoShow: true,
            isTesting: true
        };

        AdMob.prepareRewardVideoAd(options).then(
            (value : any) => {
                alert("Success-> " + value.toString()); // true
            },
            (error : any) => {
                alert("Error-> " + error.toString()); // show error
            }
        );

        // Subscibe ReWardVideo Event Listener
        AdMob.addListener("onRewardedVideoAdLoaded", (info: boolean) => {
            alert("RewardedVideoAd Loaded-> " + info);

            AdMob.showRewardVideoAd();
        });
    }

    return (
        <IonPage>
            <IonContent>
                <IonCard className="ion-padding">
                    <div>Ad Mobs: </div><br/>
                    <IonButton expand="block" onClick={init}>
                        Initialize
                    </IonButton><br/>
                    <IonButton expand="block" onClick={banner}>
                        Banner
                    </IonButton><br/>
                    <IonButton expand="block" onClick={interstitial}>
                        Interstitial
                    </IonButton><br/>
                    <IonButton expand="block" onClick={reward}>
                        Reward
                    </IonButton>
                </IonCard>
            </IonContent>
        </IonPage>
    );
};

export default AdTest;